<template>
    <div><!-- --{{loadServiceRequest}}+loadServiceRequest={{serviceRequest}}+serviceRequest={{reason}}+reason={{reason_text}}+reason_text={{title}}+title={{title_text}}+title_text={{inList_custom_id}}+inList_custom_id={{info_req}}+info_req= -->
        <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
        <div class="inMiddle-area" v-if="div_show == '1'">  
            <div class="row justify-content-center align-items-center ">
                <div class=" middleBox ">
                    <div class="whiteBG box-shadow supportHome">
                        <div class="miAppName gradientThemecolor w-100 ">
                            <div> 
                                <label class="font-weight-bold f-25">{{$t('suppReqService_support')}}</label>
                                <p>{{$t('suppReqService_howassist')}}</p>
                            </div>
                            <figure><img src="../../../../static/fxView/images/support-New.svg" alt="Image" ></figure>
                        </div>
                        <div class="cardSection">
                            <div class="card-item mt-4 border-bottom d-flex pb-4  align-items-center"> 
                                <div class=" card-icon mr-3"> 
                                     <feather type="mail" size="17px"></feather>
                                </div> 
                                <div class="card-item-title "> 
                                    <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_emailus')}}</label> 
                                    <p>{{$t('suppReqService_email')}}</p>   
                                </div>
                            </div>
                            <div class="card-item mt-4 border-bottom d-flex pb-4  align-items-center"> 
                                <div class="card-icon mr-3"> 
                                     <feather type="message-circle" size="17px"></feather>
                                </div> 
                                <div class="card-item-title "> 
                                    <label class="main-content-label tx-13 font-weight-bold mb-0"><a href=" https://direct.lc.chat/13047510/" target="_blank">{{$t('suppReqService_liveChat')}}</a></label> 
                                    <p>{{$t('suppReqService_avail24')}}</p>   
                                </div>
                            </div>
                            <div class="card-item mt-4 border-bottom d-flex pb-4  align-items-center"> 
                                <div class=" card-icon mr-3"> 
                                     <feather type="phone-outgoing" size="17px"></feather>
                                </div> 
                                <div class="card-item-title "> 
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_requestcallback')}}</label> 
                                            <p>{{$t('suppReqService_office')}}</p> 
                                        </div>
                                        <!-- <div>
                                            <p>+357-2526-2288 </p> 
                                            <p >+357-2526-2040</p> 
                                        </div> -->
                                    </div>  
                                </div>
                            </div>
                            <div class="card-item mt-4 d-flex pb-3 align-items-center"> 
                                <div class=" card-icon mr-3"> 
                                     <feather type="settings" size="17px"></feather>
                                </div> 
                                <div class="card-item-title d-flex  align-items-center justify-content-between"> 
                                    <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_support')}}</label> 
                                    <p><a href="#" class="green" @click.prevent="div_show = '2'">{{$t('suppReqService_createTicket')}}</a> </p> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        <div v-else>  
            <div class="request_changesec" v-if="!serviceRequest"> 
                <div class="row d-flex justify-content-center align-items-center">
                    <div class="col-11 col-md-12">  
                        <div class="compose_mailsec">
                            <app-profile :ticketFilter="ticketReasonList[loadServiceRequest]"  :ticketRequest="ticketRequestFrom" :accountIdFrom="account_id" ></app-profile>
                        </div>                  
                    </div> 
                </div> 
            </div>
            <div class="main_inner_section services_request mb-3" v-else>
                <div class="row no-gutters justify-content-center">
                    <div class="col-12 col-md-12 whiteBG p-2"> 
                        <div class="support_search row d-flex align-items-center justify-content-center mb-3 pt-4 pb-2"> 
                            <div class="col-6 text-center">
                                <h2 class="support_title mb-4">{{$t('suppReqService_helpSupport')}}</h2>
                                <div class="form-group field-wrapper">
                                    <input type="text" class="form-control input_search inputs" id="myInput" name="" :placeholder="$t('SearchSomething')" v-on:keyup="keymonitor">
                                    <input type="submit" class="pos_ab" value="search" name="">
                                </div>
                            </div>  
                        </div>
                        <div id="major_service_sec" class="outer_major_sersec">
                            <ul class="inner_dropdown request_lisec mb-5" id="myUL" v-if="ticketReasonList != ''">
            					<li v-for="list in ticketData[-1]" v-if="(parseInt(ticketReasonList[list].status) == 1 && parseInt(ticketReasonList[list].tickets) == 1)  && ((list == '16' && parseInt(get_user.verified_status) == 1) || (list != '16')) && iconFile[list]"><!-- v-if="(parseInt(ticketReasonList[list].status) == 1 && parseInt(ticketReasonList[list].tickets) == 1)  && ((list == '6') || (list == '12') || (list == '13') || (list == '16' && parseInt(get_user.verified_status) == 1))" -->
                                    <a href="javascript:void(0)" v-on:click.prevent="enableRequestElement(list)" v-if="iconFile[list]">
                                        <div class="icon">
                                            <img :src="'../../../../static/fxView/images/'+iconFile[list].icon" alt="Email Support">
                                        </div>
                                        <h6>{{ $t(iconFile[list].lang) }}</h6>
                                    </a>
                                    <!-- <p v-else>{{list}}</p> -->
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="goback text-center d-flex align-items-center justify-content-center mt-4">
                <a class="common_btn crossPOP btn_xs  mb-5 d-flex align-items-center" href="#" v-if="loadServiceRequest != ''" @click.prevent="backTick()">
                    <feather type="arrow-left" class="mr-1"></feather> {{$t('suppReqService_back')}}
                </a>
                <a class="common_btn crossPOP btn_xs  mb-5 d-flex align-items-center" href="#" v-else @click.prevent="div_show = '1'">
                    <feather type="arrow-left" class="mr-1"></feather> {{$t('suppReqService_back')}}
                </a>  
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
    import profileRequest from './services/profile_request'
    export default {
        name: 'SERVICES',
        mixins: [fxViewMixins],
        data () {
          return {
            pageTitle : this.$options.name,
            msg_type:'',
            response_msg:'',
            div_show : "1",
			iconFile :{ 
                '1': {'icon':  'sr_profile.png','title': "Profile",'lang':'profile'},
                '2': {'icon': 'sr_tradingaccount.png' , 'title': "Trading Account",'lang':'tradingAcc'},
				'3': {'icon':  'otherTicket.svg' , 'title': "PAMM Requests",'lang':''},
                '4': {'icon':  'otherTicket.svg' , 'title': "IB Requests",'lang':''},
                '5': {'icon':  'sr_deposit.png' , 'title': "Deposits",'lang':'Deposits'},
                '6': {'icon':  'sr_withdrawals.png' , 'title': "Withdrawals",'lang':'Withdrawals'},
				'7': {'icon':  'sr_bonus.png' , 'title': "Bonus",'lang':''},
                '8': {'icon':  'sr_vps.png' , 'title': "VPS",'lang':'VPS'},
				'9': {'icon':  'sr_reimbursement.png', 'title': "Reimbursement",'lang':''},
                '10': {'icon':  'sr_complaints.png' , 'title': "Complaints",'lang':'Complaints'},
				'11': {'icon': 'sr_compliance.png' , 'title': "Compliance",'lang':''},
                '12': {'icon': 'sr_feedback.png' , 'title': "Feedback",'lang':'Feedback'},
                '13': {'icon': 'sr_others.png' , 'title': "Others",'lang':'Others'},
                '16': {'icon': 'sr_addpayment.png', 'title': "Add Payment Method",'lang':'AddPaymentMethod'},
				'91': {'icon': 'otherTicket.svg', 'title': "Registeration Documents",'lang':''},
                '92': {'icon': 'otherTicket.svg', 'title': "Skip Documents",'lang':''},
				'94': {'icon': 'otherTicket.svg', 'title': "Become A Pro",'lang':''},
                '121' :{'icon':  'sr_profile.png','title': "REGISTERATION",'lang':'REGISTERATION'},
                '166' :{'icon':  'sr_affiliate.png','title': "Sub- Affiliates",'lang':'SubAffiliates'},
                '169' :{'icon':  'sr_promotional.png','title': "Promotional Tools",'lang':'PromotionalTools'},
                '171' :{'icon':  'sr_withdrawals.png','title': "Commission Withdrawals",'lang':'CommissionWithdrawals'},
                '179' :{'icon':  'sr_commission.png','title': "Commission structure",'lang':'Commissionstructure'},
                '184' :{'icon':  'sr_referal.png','title': "Referrals",'lang':'Referrals'},

 
            },
            loadServiceRequest : "",
            serviceRequest : true,
            

            //come request from deposit----
            ticketRequestFrom : '',
            account_id : '',
            method_id : '',
			inList_custom_id : '',
			
			showDiv : '1',
			reason : '',
			reason_text : '',
			title : '0',
			title_text : '',
			info_req : '',
          }
        }, 
        components: {
            appProfile: profileRequest
        },
		
        methods: {
            backTick(){
                this.loadServiceRequest = ''
                this.serviceRequest = true
                this.reason = '',
                this.reason_text = '',
                this.title = '0',
                this.title_text = ''
                this.inList_custom_id = ''
                this.info_req = ''
            },
			keymonitor(){
				var input, filter, ul, li, a, i, txtValue;
                  input = document.getElementById('myInput');
                  filter = input.value.toUpperCase();
                  ul = document.getElementById("myUL");
                  li = ul.getElementsByTagName('li');

                  // Loop through all list items, and hide those who don't match the search query
                  for (i = 0; i < li.length; i++) {
                    a = li[i].getElementsByTagName("a")[0];
                   
                    txtValue = a.textContent || a.innerText;
                    
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                      li[i].style.display = "";
                    } else {
                      li[i].style.display = "none";
                    }
                  }
			},
            enableRequestElement(elementName){
				this.loadServiceRequest =  elementName
				if(!parseInt(this.ticketReasonList[this.loadServiceRequest].infomration_req) || (parseInt(this.loadServiceRequest) == 16 && this.method_id != '') || (parseInt(this.loadServiceRequest) == 171 && this.method_id != '')){
					this.showDiv = '3'
					if(parseInt(this.loadServiceRequest) == 16 || parseInt(this.loadServiceRequest) == 171){
						this.chooseRequestType(this.inList_custom_id,this.ticketReasonList[this.loadServiceRequest])
					}else{
						this.chooseRequestType('',this.ticketReasonList[this.loadServiceRequest])
					}
				}else{
                    this.showDiv = '1'
                }
				this.serviceRequest = false
            },
			chooseRequestType(getInlistId,getOutListData){
                if([96,95,195].includes(parseInt(getInlistId))){
                    switch(parseInt(getInlistId)){
                        /*case 93:
                            if(this.getUserProfile.banks.filter(res => res.method == 2).length){
                                this.msg_type = 'success';
                                this.response_msg = 'success';
                                return;
                            }
                            break;*/
                        case 96:
                            if(this.getUserProfile.banks.filter(res => res.method == 3).length){
                                // skrill
                                this.msg_type = 'success';
                                this.response_msg = 'Neteller Payment Method is already added';
                                setTimeout(() => {
                                    this.response_msg = "";
                                }, 2000);
                                return;
                            }
                            break;
                        case 95:
                            if(this.getUserProfile.banks.filter(res => res.method == 2).length){
                                // neteller
                                this.msg_type = 'success';
                                this.response_msg = 'Skrill Payment Method is already added';
                                setTimeout(() => {
                                    this.response_msg = "";
                                }, 2000);
                                return;
                            }
                            break;
                        case 195:
                            if(this.getUserProfile.banks.filter(res => res.method == 4).length >= 3){
                                // crypto
                                this.msg_type = 'success';
                                this.response_msg = 'Crypto Payment Method is already added';
                                setTimeout(() => {
                                    this.response_msg = "";
                                }, 2000);
                                return;
                            }
                            break;
                        default:
                            return;
                            break;
                    }
                }
                this.reason = getOutListData.id
                this.reason_text = getOutListData.title
				this.title = '0'
                this.title_text = '' 
				if(getInlistId != '' && getInlistId != null){
					let count = 0;
					for(var key in  this.ticketReasonList[this.loadServiceRequest].categories){
						count++
						if(key == getInlistId){
							this.title = key
							this.title_text = this.ticketReasonList[this.loadServiceRequest].categories[key].title
							this.info_req = this.ticketReasonList[this.loadServiceRequest].categories[key].infomration_req
						}
						
						if(count == Object.keys(this.ticketReasonList[this.loadServiceRequest].categories).length){
							if(!parseInt(this.info_req)){
								this.showDiv = '3'
							}else{
								this.showDiv = '2'
							}
						}
					}
				}else{
					this.showDiv = '3'
				}
            }
		},
        created(){
            if(parseInt(this.$route.params.ticketData) == 16){
                this.div_show = '2'
				if(this.$route.params.account_id){
					this.ticketRequestFrom = 'deposit'
					this.account_id = this.$route.params.account_id
				}
				if(this.$route.params.page == 'profile'){
					this.ticketRequestFrom = 'profile'
					this.account_id = ''
				}
                if(this.$route.params.page == 'withdrawal'){
                    this.ticketRequestFrom = 'withdrawal'
                    this.account_id = ''
                }

                
                
                this.method_id = this.$route.params.method_id
				if(this.method_id == 1){
					this.inList_custom_id = 93
				}else if(this.method_id == 2){
					this.inList_custom_id = 95
				}else if(this.method_id == 3){
					this.inList_custom_id = 96
				}else if(this.method_id == 5){
					this.inList_custom_id = 107
				}else if(this.method_id == 4){
					this.inList_custom_id = 195
				}
                this.enableRequestElement(16)
            }
            if(parseInt(this.$route.params.ticketData) == 171){
                if(this.$route.params.page == 'withdrawal'){
                    this.ticketRequestFrom = 'withdrawal'
                    this.account_id = ''
                }
                this.div_show = '2'
                this.inList_custom_id = this.$route.params.method_id
                this.method_id = this.$route.params.method_id
                this.enableRequestElement(171)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/request_services.vue